import { Entity, PrimaryGeneratedColumn, Column } from 'typeorm';

@Entity()
export class CollegeCodesAndSymobols {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column({ name: 'center_code', type: 'int' })
    centerCode: number;

    @Column({ name: 'center_name', type: 'varchar' })
    centerName: string;

    @Column({ name: 'district', type: 'int' })
    district: number;

    @Column({ name: 'left', type: 'int' })
    left: number;

    @Column({ name: 'Top', type: 'int' })
    top: number;

    @Column({ name: 'Symbol', type: 'varchar' })
    symbol: string;
}
